<div class="panel-footer">
  <ng-content></ng-content>
</div>
